<script setup></script>

<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="lock 1" clip-path="url(#clip0_7831_12457)">
      <g id="Group">
        <path
          id="Vector"
          d="M15.5834 7.33415V5.50081C15.5799 4.28632 15.0959 3.12256 14.2371 2.26378C13.3784 1.405 12.2146 0.920987 11.0001 0.91748C9.78561 0.920987 8.62186 1.405 7.76308 2.26378C6.9043 3.12256 6.42029 4.28632 6.41678 5.50081V7.33415"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M17.4167 9.62598H4.58333C3.57081 9.62598 2.75 10.4468 2.75 11.4593V19.251C2.75 20.2635 3.57081 21.0843 4.58333 21.0843H17.4167C18.4292 21.0843 19.25 20.2635 19.25 19.251V11.4593C19.25 10.4468 18.4292 9.62598 17.4167 9.62598Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M11.0001 16.0426C12.0126 16.0426 12.8334 15.2218 12.8334 14.2093C12.8334 13.1968 12.0126 12.376 11.0001 12.376C9.98759 12.376 9.16678 13.1968 9.16678 14.2093C9.16678 15.2218 9.98759 16.0426 11.0001 16.0426Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_4"
          d="M11 16.0425V18.3341"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
</template>
